/**
 * Shared axios interceptor guard for the AeroGuard frontend.
 *
 * The shared axios clients (AuthContext.js + services/api.js) have
 * baseURL set to `${REACT_APP_BACKEND_URL}/api`. Paths passed to
 * `api.get(...)` MUST start with a single '/' (relative to /api).
 *
 * Calling `api.get('/api/foo')` produces '/api/api/foo' → 404.
 * This interceptor catches that mistake at request-time, auto-corrects
 * the URL, and (in non-production) logs a clear error so the developer
 * fixes the call site.
 */
export const apiDoublePrefixGuard = (config) => {
  if (typeof config.url === 'string' && config.url.startsWith('/api/')) {
    const fixed = config.url.replace(/^\/api\//, '/');
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(
        `[api] '/api' double-prefix detected on '${config.url}'. ` +
        `The shared axios instance already has baseURL ending in '/api'. ` +
        `Auto-correcting to '${fixed}'. Please update the call site.`
      );
    }
    config.url = fixed;
  }
  return config;
};
